import { Flex } from "@chakra-ui/react";
import { debounce } from "lodash/fp";
import { useEffect, useMemo, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { OFQuantityCounter } from "design_system/components/OFQuantityCounter";
import { areDisabledCheckoutButtonsState, promoCodeState } from "src/states";

type Props = {
  color?: string;
  onQuantityChange: (cartItem: any) => void;
  quantity?: number;
  [itemProps: string]: any;
};

const InputCounter = ({ onQuantityChange, quantity, ...itemProps }: Props) => {
  const [stateQuantity, setQuantity] = useState(quantity);
  const promoCode = useRecoilValue(promoCodeState);
  const setDisabledCheckoutButtons = useSetRecoilState(areDisabledCheckoutButtonsState);

  const {
    sysId: cartItemId,
    product: { id: productId }
  } = itemProps;

  const onQuantityChangeDebounce = useMemo(
    () =>
      debounce(1000, async (currentStateQuantity) => {
        if (quantity !== currentStateQuantity) {
          onQuantityChange({ cartItemId, productId, quantity: currentStateQuantity });
          setDisabledCheckoutButtons(false);
        }
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cartItemId, productId, quantity, promoCode]
  );

  const onMinusClick = () => {
    if (stateQuantity > 1) {
      setDisabledCheckoutButtons(true);
    }
    setQuantity(stateQuantity > 1 ? stateQuantity - 1 : 1);
  };

  const onPlusClick = () => {
    setDisabledCheckoutButtons(true);
    setQuantity(stateQuantity + 1);
  };

  useEffect(() => {
    onQuantityChangeDebounce(stateQuantity);
  }, [stateQuantity, onQuantityChangeDebounce]);

  return (
    <Flex>
      <OFQuantityCounter
        onMinusClick={onMinusClick}
        onPlusClick={onPlusClick}
        number={stateQuantity}
      />
    </Flex>
  );
};

export default InputCounter;
